var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Playground Klessen")]),_vm._l((_vm.getItems),function(item){return _c('h6',{key:item.id},[_vm._v(_vm._s(item.name))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }